import script from "./PolicyPerspective.vue?vue&type=script&lang=ts&setup=true"
export * from "./PolicyPerspective.vue?vue&type=script&lang=ts&setup=true"

import "./PolicyPerspective.vue?vue&type=style&index=0&id=693ac6ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693ac6ea"]])

export default __exports__